import { Scene } from 'phaser'
import { TacticalDisplay } from '../display/tactical-display'
import { Point, equals } from '../math/point'
import { World } from '../model/world'
import { gameGridSquares, viewport } from './game-config'
import { Graphics } from '../display/graphics'
import { GameUpdate, GameUpdateGlobalState } from './game-update'
import { ViewTransform, Viewport } from './view-transform'
import { GridDisplay } from '../display/grid-display'
import { Vector } from '../math/vector'
import { WorldBuilder } from '../builder/world-builder'
import { PlayerMoveState } from './game-update/player-turn'
import { WorldGrid } from '../model/world-grid'

import { Transform } from '../math/transform'

import * as WebFont from 'webfontloader'

import { BLUE_LINE } from '../display/lines'
import { Angle } from '../math/angle'
import { roll } from '../model/weapon'
import { range } from '../math/util'

import clone from 'immutability-helper'
import { ShipDisplay } from '../display/ship-display'
import { ScreenDisplay } from '../display/screen-display'
import { ConsoleScreen, ScreenChar } from '../console/console-screen'
import { Size } from '../math/size'
import { ConsoleDraw, BoxStyleType } from '../console/console-draw'
import { Rectangle } from '../math/rectangle'
import { ReadoutUpdate } from './game-update/readout-update'


export class GameScene extends Scene {
  private phaserGraphics: Phaser.GameObjects.Graphics
  // private screenPhaserGraphics: Phaser.GameObjects.Graphics

  private world: World
  private graphics: Graphics

  private viewTransform: ViewTransform
  private transform = new Transform()

  private inputContext: GameUpdate

  private screenPointer: Point = new Point(0, 0)

  constructor() {
    super("game-scene")
  }

  preload() {
    // this.load.image('player', 'assets/oryx_16-bit_sci-fi/sliced/vehicles_sliced/images/oryx_16bit_scifi_vehicles_145.png')
    this.load.image('player', 'assets/images/Sprite-0001.png')
    this.load.image('enemy1', 'assets/oryx_16-bit_sci-fi/sliced/vehicles_sliced/images/oryx_16bit_scifi_vehicles_93a.png')
    this.load.image('enemy2', 'assets/oryx_16-bit_sci-fi/sliced/vehicles_sliced/images/oryx_16bit_scifi_vehicles_89.png')

    this.load.image('player-icon', 'assets/images/Sprite-0003.png')

    this.load.spritesheet('font-0', 'assets/font-images/cp437_8x16_fixedsys-trans.png', { frameWidth: 8,  frameHeight: 16 })
    this.load.spritesheet('font-1', 'assets/font-images/rex_paint_16x16.png',     { frameWidth: 16, frameHeight: 16 })
    this.load.spritesheet('font-2', 'assets/font-images/rogue_yun_16x16.png',     { frameWidth: 16, frameHeight: 16 })

    this.load.audio('phaser1', 'assets/sound/phaser-1.wav')
    this.load.audio('photon1', 'assets/sound/photon-1.wav')
  }

  create() {
    this.phaserGraphics = this.add.graphics()
    this.world = WorldBuilder.build(new WorldGrid(gameGridSquares, 10))

    this.viewTransform = new ViewTransform(viewport)
    // console
    const origin = new Point(viewport.rectangle().p1.x + 25, viewport.rectangle().p0.y + 14)

    const readoutUpdate = new ReadoutUpdate(origin, this.make)
    this.inputContext = new GameUpdate(new PlayerMoveState(), new GameUpdateGlobalState(readoutUpdate))


    //
    this.graphics = new Graphics(() => this.world.grid, this.viewTransform, this.phaserGraphics, this.sound, this.make)
    //

    //
    const entities = [this.world.ship, ...this.world.enemies]
    entities.forEach(e => e.sprite.addImage(this))

    // this.add.image(100, 100, 'player-icon')

    //
    // this.input.keyboard.on('keydown_ESC', () => this.close )
    // this.input.keyboard.on('keydown_BACKTICK', () => this.close)

    this.input.on('pointermove', (pointer: Phaser.Input.Pointer) => {
      const worldPointer = this.toWorld(pointer)
      if (worldPointer !== undefined) {
        this.world = clone(this.world, {pointer: {$set: worldPointer}})
      }
    })

    this.input.on('pointerup', (pointer: Phaser.Input.Pointer) => {
      const worldPointer = this.toWorld(pointer)
      if (worldPointer !== undefined) {
        this.world = clone(this.world, {pointer: {$set: worldPointer}, selected: {$set: true}})
      }
    })
  }

  specialShields() {
    const boost = roll(5).reduce((a,b) => a + b, 0)
    const s = this.world.ship.shields.map(s => s + boost)

    const newShip = this.world.ship.setShields([s[0], s[1], s[2], s[3]])
    const world0 = this.world.setPlayerShip(newShip)

    this.world = world0
  }

  specialEngines() {
    const newShip = clone(this.world.ship, {speed: {$set: this.world.ship.speed+20}, turnSpeed: {$set: this.world.ship.turnSpeed+10}})
    const world0 = this.world.setPlayerShip(newShip)

    this.world = world0
  }

  // convert screen pointer to world point
  protected toWorld(pointer: Phaser.Input.Pointer): Point | undefined {
    this.screenPointer = new Point(pointer.x, pointer.y)

    if (viewport.rectangle().within(this.screenPointer)) {
      const mat2d = this.viewTransform.screenToWorld(this.world.grid)
      return this.transform.convert(this.screenPointer, mat2d)
    }

    // return this.world.pointer
  }

  update(time: number, delta: number): void {
    this.world = this.inputContext.update(this.world, delta)
    this.inputContext.draw(this.world, this.graphics)
  }
}
